var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotitfication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.908,
    height: 24.624,
    viewBox: "0 0 17.908 24.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6006",
    "data-name": "Group 6006",
    transform: "translate(8220 -10967.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6005",
    "data-name": "Group 6005",
    transform: "translate(-278 14548.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18057",
    "data-name": "Path 18057",
    d: "M171.921,33.6a1.117,1.117,0,0,0-1.119,1.119V57.107a1.117,1.117,0,0,0,1.119,1.119h15.67a1.117,1.117,0,0,0,1.119-1.119V34.721a1.117,1.117,0,0,0-1.119-1.119Zm10.861,2.789a.56.56,0,0,1,.472.936L179.337,41.8a.58.58,0,0,1-.752.079L176.346,40.2a.56.56,0,1,1,.665-.9l1.828,1.373,3.576-4.092a.565.565,0,0,1,.367-.192Zm-8.622,8.4h11.193a.56.56,0,0,1,0,1.119H174.16a.56.56,0,1,1,0-1.119Zm0,4.477h11.193a.56.56,0,0,1,0,1.119H174.16a.56.56,0,1,1,0-1.119Zm0,4.477h11.193a.56.56,0,0,1,0,1.119H174.16a.56.56,0,1,1,0-1.119Z",
    transform: "translate(-8112.802 -3614.602)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 7.278,
    cy: 4.292,
    rx: 7.278,
    ry: 4.292,
    transform: "translate(-7939.838 -3579.66)",
    fill: "#6d44e5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(-7937.244 -3579.688)",
    fill: "#85e6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18058",
    "data-name": "Path 18058",
    d: "M33.878,87.261a.4.4,0,0,0-.16-.327.627.627,0,0,0-.4-.141.62.62,0,0,0-.409.131l-3.831,2.967-1.253-1.115a.683.683,0,0,0-.81-.034.407.407,0,0,0-.187.315.39.39,0,0,0,.145.333l1.65,1.47a.582.582,0,0,0,.256.128.716.716,0,0,0,.3.009.654.654,0,0,0,.267-.116l4.259-3.3a.412.412,0,0,0,.172-.321Z",
    transform: "translate(-7963.304 -3663.812)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotitfication);
export default __webpack_public_path__ + "static/media/notitfication.8dc4299bce7aa600487d5daa883fca6e.svg";
export { ForwardRef as ReactComponent };